import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './Dashboard'
import AdApprovals from './AdApprovals'
import Merchants from './Merchants'
import Businesses from './Businesses'
import AppUsers from './AppUsers'
import Notifications from './Notifications'
import Analytics from './Analytics'
import AdminManagement from './AdminManagement'
import Incidents from './Incidents'
import { useAdminAuth } from '../../hooks/useAdminAuth'
import { LoadingSpinner } from '../../components/common/UI'

const RoleProtectedRoute = ({ 
  children, 
  allowedRoles 
}: { 
  children: React.ReactNode
  allowedRoles?: string[]
}) => {
  const { admin, loading, isAuthenticated } = useAdminAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isAuthenticated || !admin) {
    return <Navigate to="/admin" replace />
  }

  if (allowedRoles && !allowedRoles.includes(admin.role)) {
    return <Navigate to="/admin/dashboard" replace />
  }

  return <>{children}</>
}

export default function Admin() {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      
      <Route 
        path="admins" 
        element={
          <RoleProtectedRoute allowedRoles={['SUPER_ADMIN']}>
            <AdminManagement />
          </RoleProtectedRoute>
        } 
      />
      
      <Route path="users" element={<AppUsers />} />
      <Route path="companies" element={<Businesses />} />
      
      <Route 
        path="ads" 
        element={
          <RoleProtectedRoute allowedRoles={['SUPER_ADMIN', 'ADMIN']}>
            <AdApprovals />
          </RoleProtectedRoute>
        } 
      />
      
      <Route path="merchants" element={<Merchants />} />
      
      <Route 
        path="notifications" 
        element={
          <RoleProtectedRoute allowedRoles={['SUPER_ADMIN', 'ADMIN']}>
            <Notifications />
          </RoleProtectedRoute>
        } 
      />
      
      <Route path="analytics" element={<Analytics />} />
      
      <Route 
        path="incidents" 
        element={
          <RoleProtectedRoute>
            <Incidents />
          </RoleProtectedRoute>
        } 
      />
      
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  )
}